import React, { useState } from "react";
import { Button, Pane, MenuSection, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import TableComponent from "../../components/TableComponent";
import NavComponent from "../../components/NavComponent";
import { PublisherDetail } from "./PublisherDetail";
import { PublisherFilters } from "../../components/PublisherFilters";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { createStripesSource } from "../../utils/createStripesSource";
import { usePublisherFilters } from "../../hooks/usePublisherFilters";
import { usePublisherData } from "../../hooks/usePublisherData";
import { usePublisherTable } from "../../hooks/usePublisherTable";
import { usePublisherActions } from "../../hooks/usePublisherActions";
import { usePageSize } from "../../hooks/usePageSize";
var PublisherList = function () {
    var formatMessage = useIntl().formatMessage;
    var history = useHistory();
    var _a = useState(true), filterPaneIsVisible = _a[0], setFilterPaneIsVisible = _a[1];
    var filtersHook = usePublisherFilters();
    var _b = usePageSize(), pageSize = _b.pageSize, createPageSizeHandler = _b.createPageSizeHandler;
    var dataHook = usePublisherData(filtersHook.appliedFilters, filtersHook.buildQuery, pageSize);
    var actionsHook = usePublisherActions();
    var columns = usePublisherTable(actionsHook.handleRowClick).columns;
    var toggleFilterPane = function () { return setFilterPaneIsVisible(function (prev) { return !prev; }); };
    var handlePageSizeChange = createPageSizeHandler(dataHook.fetchMoreData);
    var handleApplyFilters = function () {
        dataHook.resetPageOffset();
        filtersHook.handleApplyFilters();
    };
    var handleClearFilters = function () {
        dataHook.resetPageOffset();
        filtersHook.handleClearFilters();
    };
    var source = createStripesSource({
        ky: null,
        data: dataHook.publishersData,
        totalRecords: dataHook.totalRecords,
        isLoading: dataHook.isLoading,
        isError: dataHook.isError,
        isLoaded: true,
        fetchMore: function () {
            return dataHook.fetchMoreData(dataHook.pageOffset + dataHook.pageSize);
        },
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(RecekPaneSet, null,
            filterPaneIsVisible && (React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                    id: "ui-br-agency.pane.title.navigation",
                }) },
                React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                    React.createElement(NavComponent, null),
                    React.createElement(Button, { buttonStyle: "none", id: "clickable-reset-all", disabled: !filtersHook.isAnyFilterActive(), marginBottom0: true, onClick: handleClearFilters },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.button.resetAll" })),
                    React.createElement(PublisherFilters, { filters: filtersHook.filters, onFilterChange: filtersHook.handleFilterChange, onStatusChange: filtersHook.handleStatusChange, onApplyFilters: handleApplyFilters, hasUnappliedChanges: filtersHook.hasUnappliedChanges() })))),
            React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-br-agency.publisher.table.title" }), paneSub: formatMessage({ id: "ui-br-agency.table.subtitle.records-found" }, { count: dataHook.totalRecords }) },
                React.createElement(TableComponent, { data: dataHook.publishersData, columns: columns, pageSize: pageSize, onPageSizeChange: handlePageSizeChange, totalCount: dataHook.totalRecords, pagingOffset: dataHook.pageOffset, onNeedMoreData: function (offset) { return dataHook.fetchMoreData(offset); }, searchTerm: "", filterPaneIsVisible: filterPaneIsVisible, toggleFilterPane: toggleFilterPane, source: source })),
            actionsHook.selectedPublisher && (React.createElement(Pane, { id: "detailPane", defaultWidth: "35%", paneTitle: formatMessage({
                    id: "ui-br-agency.publisher.detail.pane.title",
                }), onClose: actionsHook.handleCloseDetail, dismissible: true, actionMenu: function () { return (React.createElement(MenuSection, { label: formatMessage({
                        id: "ui-br-agency.action.menu.label",
                    }), id: "actions-menu" },
                    React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                            var _a;
                            history.push("/bragency/publisher-prefixes?publisherId=".concat((_a = actionsHook.selectedPublisher) === null || _a === void 0 ? void 0 : _a.sourceId));
                        }, fullWidth: true },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.publisher.detail.action.publisherPrefixes" })))); } },
                React.createElement(PublisherDetail, { publisher: actionsHook.selectedPublisher }))))));
};
export default PublisherList;
